const domesticProjects = [
    {
        id: "D001",
        location: "Thotawaththa",
        owner: "Mr. M.Y.M. Rials",
        capacity: "20kW",
        inverter: "Growatt 20kW Inverter",
        panel: "Trina Solar 615W - 33 Nos",
        images: [
            "../images/projects/D001_01.jpg",
            "../images/projects/D001_02.jpg",
            "../images/projects/D001_03.jpg",
            "../images/projects/D001_04.jpg",
            "../images/projects/D001_05.jpg"
        ]
    },
    {
        id: "D002",
        location: "Melagama, Wadduwa",
        owner: "Mrs. S.D.L.W. Sandanayaka",
        capacity: "15kW",
        inverter: "Goodwe 20kW Inverter",
        panel: "Trina Solar 615W - 26 Nos",
        images: [
            "../images/projects/D002_01.jpg",
            "../images/projects/D002_02.jpg",
            "../images/projects/D002_03.jpg",
            "../images/projects/D002_04.jpg",
            "../images/projects/D002_05.jpg"
        ]
    },
    {
        id: "D003",
        location: "Moratuwa Katukurunda",
        owner: "Mr. L.J.M. Ramanayaka",
        capacity: "7kW",
        inverter: "Solis 06kW Inverter",
        panel: "Trina Solar 615W - 12 Nos",
        images: [
            "../images/projects/D003_01.jpg",
            "../images/projects/D003_02.jpg",
            "../images/projects/D003_03.jpg",
            "../images/projects/D003_04.jpg",
            "../images/projects/D003_05.jpg"
        ]
    },
    {
        id: "D004",
        location: "Moratuwa Katukurunda",
        owner: "Mr. B.H. Mendis",
        capacity: "7kW",
        inverter: "Solis 06kW Inverter",
        panel: "Trina Solar 615W - 12 Nos",
        images: [
            "../images/projects/D004_01.jpg",
            "../images/projects/D004_02.jpg",
            "../images/projects/D004_03.jpg",
            "../images/projects/D004_04.jpg",
            "../images/projects/D004_05.jpg"
        ]
    },
    {
        id: "D005",
        location: "Moratuwa",
        owner: "Mr. L.K.S.K.N. Fernando",
        capacity: "5kW",
        inverter: "Growatt 05kW Inverter",
        panel: "Trina Solar 615W - 9 Nos",
        images: [
            "../images/projects/D005_01.jpg",
            "../images/projects/D005_02.jpg",
            "../images/projects/D005_03.jpg",
            "../images/projects/D005_04.jpg",
            "../images/projects/D005_05.jpg"
        ]
    },
    {
        id: "D006",
        location: "Moratuwa",
        owner: "Mr. M.N.J. Perera",
        capacity: "6kW",
        inverter: "Growatt 05kW Inverter",
        panel: "Trina Solar 615W - 10 Nos",
        images: [
            "../images/projects/D006_01.jpg",
            "../images/projects/D006_02.jpg",
            "../images/projects/D006_03.jpg",
            "../images/projects/D006_04.jpg",
            "../images/projects/D006_05.jpg"
        ]
    },
    {
        id: "D007",
        location: "Kaluthara South",
        owner: "Mr. P.R. Jayaweera",
        capacity: "5kW",
        inverter: "Growatt 05kW Inverter",
        panel: "Trina Solar 615W - 9 Nos",
        images: [
            "../images/projects/D007_01.jpg",
            "../images/projects/D007_02.jpg",
            "../images/projects/D007_03.jpg",
            "../images/projects/D007_04.jpg",
            "../images/projects/D007_05.jpg"
        ]
    },
    {
        id: "D008",
        location: "Wadduwa Pothupitiya",
        owner: "Mr. M.H.A.L. Gunathilaka",
        capacity: "7kW",
        inverter: "Solis 06kW Inverter",
        panel: "TRINA Solar 615W - 12 Nos",
        installationType: "Domestic",
        images: [
            "../images/projects/D008_01.jpg",
            "../images/projects/D008_02.jpg",
            "../images/projects/D008_03.jpg",
            "../images/projects/D008_04.jpg",
            "../images/projects/D008_05.jpg"
        ]
    },
    {
        id: "D009",
        location: "Panadura Walapola",
        owner: "Mr. Anjula Perera",
        capacity: "6kW",
        inverter: "Solis 05kW Inverter",
        panel: "JINKO 595W - 10 Nos",
        installationType: "Domestic",
        images: [
            "../images/projects/D009_01.jpg",
            "../images/projects/D009_02.jpg",
            "../images/projects/D009_03.jpg",
            "../images/projects/D009_04.jpg",
            "../images/projects/D009_05.jpg"
        ]
    },
    {
        id: "D010",
        location: "Wadduwa",
        owner: "Mr. Asanga Udugahapaththuwa",
        capacity: "10kW",
        inverter: "Solis 10kW Inverter",
        panel: "Trina 615W - 17 Nos",
        installationType: "Domestic",
        images: [
            "../images/projects/D010_01.jpg",
            "../images/projects/D010_02.jpg",
            "../images/projects/D010_03.jpg",
            "../images/projects/D010_04.jpg",
            "../images/projects/D010_05.jpg"
        ]
    }
];

export default domesticProjects;
